import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import { Button, useMediaQuery } from "@mui/material";
import { Vocabulary } from "../../../Utils/Vocabulary";

type SelectedVariantsButtonsProps = {
  selectedVariants: Array<number>;
  handleRemoveVariant: () => void;
  undoDeleteVariant: (selectedVariants: Array<number>) => void;
  editPriceOrQuantity: () => void;
};
export default function SelectedVariantsButtons(
  props: SelectedVariantsButtonsProps
) {
  const {
    selectedVariants,
    handleRemoveVariant,
    undoDeleteVariant,
    editPriceOrQuantity,
  } = props;
  const phoneStyle = useMediaQuery("(max-width: 800px)");

  return (
    <div
      style={
        phoneStyle
          ? {}
          : {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }
      }
    >
      <div>
        <Button
          color="error"
          variant="outlined"
          onClick={handleRemoveVariant}
          fullWidth={phoneStyle ? true : false}
          style={{ marginRight: 10, marginBottom: 10 }}
        >
          <DeleteForeverIcon color="error" style={{ marginRight: 10 }} />
          {Vocabulary.removeVariants}
        </Button>
        <Button
          color="warning"
          variant="outlined"
          onClick={() => undoDeleteVariant(selectedVariants)}
          fullWidth={phoneStyle ? true : false}
          style={{ marginRight: 10, marginBottom: 10 }}
        >
          <RestoreFromTrashIcon color="warning" style={{ marginRight: 10 }} />
          {Vocabulary.restoreVariants}
        </Button>
      </div>
      <div>
        <Button
          color="primary"
          variant="outlined"
          onClick={editPriceOrQuantity}
          fullWidth={phoneStyle ? true : false}
          style={{ marginRight: 10, marginBottom: 10 }}
        >
          <EditIcon color="primary" style={{ marginRight: 10 }} />
          {Vocabulary.editPriceAndQuantity}
        </Button>
      </div>
    </div>
  );
}
